import { Component, Input } from '@angular/core';
import { AdminService } from '../../../services/admin.service';
import { Companies } from '../../../interfaces/admin/Company';
import { ServerResponseObject } from '../../../interfaces/ServerResponse';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormGroup, FormsModule, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'search-company',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    MatProgressSpinner,
    ReactiveFormsModule
],
  templateUrl: './search-company.component.html',
  styleUrl: './search-company.component.scss'
})
export class SearchCompanyComponent {

  @Input() searchCompanyForm!: FormGroup;
  @Input() companyCallback!: Function;

  constructor(private adminService: AdminService) { }

  companyOptions: { id: string; name: string }[] = [];
  private companySearchTimer: any;

  searchLoading: boolean = false;

  safeCallback(){
    if(this.companyCallback) this.companyCallback();
  }

  onCompanyInput(value: string) {
    if (this.companySearchTimer) clearTimeout(this.companySearchTimer);
    const q = (value || '').trim();
    if (q.length < 2) {
      this.companyOptions = [];
      return;
    }
    this.companySearchTimer = setTimeout(() => this.getCompaniesList(q), 350);
  }

  triggerCompanySearch(value: string) {
    if (this.companySearchTimer) clearTimeout(this.companySearchTimer);
    const q = (value || '').trim();
    if (q.length === 0) return;
    this.getCompaniesList(q);
  }

  trackByCompany = (_: number, item: { id: string; name: string }) => item.id;

  getCompaniesList(search_text: string) {
    this.searchLoading = true;
    this.adminService.ListCompanies(search_text, 1, 10).subscribe({
      next: (res: ServerResponseObject<Companies>) => {
        this.companyOptions = (res.result?.companies || []).map(c => ({ id: c.id, name: c.name }));
        this.searchLoading = false;
      },
      error: () => {
        this.companyOptions = [];
        this.searchLoading = false;
      }
    });
  }
}
